import { Button,Flex,Typography } from "../../../../../../shared/frontend/ui";
import React from "react";
import { spacing } from "../design-system";
import { useI18n } from "../i18n/useI18n";
import { formatNumber } from "../units/format";
import { useEffectiveUnits } from "../units/useEffectiveUnits";
import { useGlobalStudioContext } from "./useGlobalStudioContext";

/**
 * Hinweis im Listenergebnis: setzt den Header-Studio-Scope auf alle zugreifbaren Studios.
 */
export function StudioScopeWidenHint(props: { hitCount: number }) {
  const { text } = useI18n();
  const { scopeLabel, setSelectedStudioIds } = useGlobalStudioContext();
  const units = useEffectiveUnits();
  const message = props.hitCount === 0
    ? text("No matches in studio scope").replace("{0}", scopeLabel)
    : text("Few matches in studio scope")
      .replace("{0}", formatNumber(props.hitCount, units, { maximumFractionDigits: 0 }))
      .replace("{1}", scopeLabel);

  return (
    <Flex justify="center" align="baseline" gap={spacing.sm} wrap="wrap" style={{ width: "100%" }}>
      <Typography.Text type="secondary">{message}</Typography.Text>
      <Button
        type="link"
        size="small"
        onClick={() => setSelectedStudioIds([])}
        style={{ padding: 0, height: "auto" }}
      >
        {text("Search all studios")}
      </Button>
    </Flex>
  );
}
